import styled from 'styled-components';
import { FaRegEnvelope, FaRegBuilding, FaPhoneVolume } from 'react-icons/fa';
import { Button, MOBILE, LARGE, BodyText, Card as PantheonCard } from '@minerva-analytics/pantheon';
import { SALMON, SKY_BLUE } from '../../theme';

const ContactUsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (max-width: ${LARGE}) {
    padding: 2rem;
  }

  @media (max-width: ${MOBILE}) {
    padding: 2rem;
  }
`;

const CardContent = styled.div`
  max-width: 30rem;
  margin: 0 auto;
  padding: 3rem 5rem 5rem 4rem;

  @media (max-width: ${LARGE}) {
    padding: 2rem;
  }

  @media (max-width: ${MOBILE}) {
    padding: 2rem;
  }
`;

const IconText = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const MailIcon = styled(FaRegEnvelope)`
  color: ${SALMON};
  height: 1.3rem;
  width: 1.3rem;
  margin-right: 1rem;
  overflow: visible;
  border-radius: 50%;
  padding: 0.5rem;
  box-shadow: 0 0 0 0.1rem darkgray;
`;
const BuildingIcon = styled(FaRegBuilding)`
  color: ${SALMON};
  height: 1.3rem;
  width: 1.3rem;
  margin-right: 1rem;
  overflow: visible;
  border-radius: 50%;
  padding: 0.5rem;
  box-shadow: 0 0 0 0.1rem darkgray;
`;
const PhoneIcon = styled(FaPhoneVolume)`
  color: ${SALMON};
  height: 1.3rem;
  width: 1.3rem;
  margin-right: 1rem;
  overflow: visible;
  border-radius: 50%;
  padding: 0.5rem;
  box-shadow: 0 0 0 0.1rem darkgray;
  transform: rotate(320deg);
`;

const SubscribeButton = styled(Button)`
  &&& {
    padding: 0.55rem 2.5rem;

    @media (max-width: ${MOBILE}) {
      width: 100%;
      padding: 0.55rem 0.3rem;
    }
  }
`;

const TinyBodyText = styled(BodyText)`
  &&&{
    font-size: 14px;
    margin-bottom: 0.4rem;
  }
`;

const Card = styled(PantheonCard)`
  border-top: 1rem solid ${SKY_BLUE};
`;
export {
  ContactUsContainer,
  IconText,
  MailIcon,
  BuildingIcon,
  PhoneIcon,
  SubscribeButton,
  CardContent,
  TinyBodyText,
  Card
};
